// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inv-card-title {
	font-size: 1.1em;
	height: 50px;
	overflow: hidden;
}

@media (max-width: 576px) {
	.inv-card-title {
		font-size: 1.75em;
	}
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/inv-card-styles.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD","sourcesContent":[".inv-card-title {\n\tfont-size: 1.1em;\n\theight: 50px;\n\toverflow: hidden;\n}\n\n@media (max-width: 576px) {\n\t.inv-card-title {\n\t\tfont-size: 1.75em;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
